import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import FullScreenLoader from '@frontend/components/FullScreenLoader';

import { useUnifiedAgentByHumanReadableId } from '../hooks';

export function AgentRouterPage() {
  const params = useParams();
  const navigate = useNavigate();

  const agentIdFromUrl = params.humanReadableAgentId;
  const { agent, agentType } = useUnifiedAgentByHumanReadableId(agentIdFromUrl || '');

  useEffect(() => {
    if (agent && agentType) {
      if (agentType === 'specialized') {
        navigate(`/agents/specialized/${agent.id}`);
      } else if (agentType === 'workflow') {
        navigate(`/agents/workflow/edit/${agent.id}`);
      }
    }
  }, [agent, agentType, navigate]);

  return <FullScreenLoader />;
}
